export default __webpack_public_path__ + "static/media/slide3.86f73602.jpg";